import React, { Component, Fragment } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import DataTable from '../JqueryDataTable';
import * as ACTIVE_TYPES from '../../redux/actions/types';
import * as ACTION_TYPES from '../../redux/actions/types';
import JobsFilterM from './JobsFilterM';
import NoDataIndication from '../TableLoader';
import { apiHalper } from '../../helpers/ApiHelper';
import moment from 'moment';
import { jwtDecode } from '../../helpers/jwt_helper';
import DeleteModal from './DeleteModal';
import Modal from 'react-bootstrap/Modal';
import InfiniteScroll from "react-infinite-scroll-component";
import ScrollLoader from '../ScrollLoader';
import LoaderComponent from '../LoaderComponent';
import { toster_error, toster_sucess } from '../../helpers/toster_helper';
class PostList extends Component {

    _ismounted = false;

    constructor(props) {
        super(props);
        this.state = {
            isSGLoader:false,
            isLoader: false,
            istester: false,
            page: 1,
            search: '',
            allJobs: [],
            totalRecord: 0,
            sortByVal: 1,
            rangeVal: 0,
            manuDate: null,
            startDate: null,
            endDate: null,
            cJobStatus: 0,
            iAdmin: 0,
            typeServices: 0,
            selectedCountry: null,
            isClearable: true,
            apiMessage: '',
            mainServices: [],
            isDeleModal: false,
            deleteId: null,
            selectedRow:[],
            isSelectAll:false,
            isBidModal: false,
            aiAgentData:[],
            messageApi:'',
            openBiddingModal: false,
            jobPostId: 0,
            aiProfileId:0,
            deadline_type: "days",
            currency:"USD",
            message:"",
            amount:0,
            deadline_value:0,
            formError: {
                amount: '',
                message: '',
                currency: '',
                deadline_type:'',
                deadline_value: '',
            },
            formValid: {
                amount: false,
                message: false,
                currency: false,
                deadline_type: false,
                deadline_value: false,
            },
            

        }
    }

    componentDidMount() {
        this._ismounted = true;
        this.setState({
            startDate: new Date(),
            endDate: new Date()
        });
        const { page, istester, search } = this.state;
        this.getAllJobsApi(page, istester, search);
        this.getMainServices();
    }

    componentWillUnmount() {
        this._ismounted = false;
    }

    getMainServices = async () => {
        try {

            const headers = {
                'Authorization': sessionStorage.getItem('token')
            }

            const response = await apiHalper('getMainServices', 'GET', null, headers);
            const res = response.data;
            if (res.status) {
                const data = jwtDecode(res.data);
                const newArray = data.map(info => {
                    const inputName = info.name.split(" ").join('_');
                    return { id: info.id, name: info.name, inputID: inputName.toLowerCase() }
                });
                this.setState({
                    mainServices: newArray
                })
            } else {

            }

        } catch (err) {
            console.log(err.message);
        }
    }
    getAIAgentsListApi = async (page) => {
        // if (this._ismounted) {
            try {
                // const id = this.state.profileId;
                const headers = {
                    'Authorization': sessionStorage.getItem('token'),
                }
                let formData = new FormData();
                formData.append('page_no', page)

                const res = await apiHalper('getAIAgents', 'POST', formData, headers);
                if (res.data.status === true) {
                    const data = jwtDecode(res.data.data);
                    console.log(data)
                        if(page > 1) {
                            this.setState({
                                isLoader: true,
                                isSGLoader: true,
                                messageApi: '',
                                aiAgentData: [...this.state.aiAgentData, ...data.data]
                            })
                        } else {
                            this.setState({
                                isLoader: true,
                                isSGLoader: true,
                                messageGigApi: '',
                                aiAgentData: data.data
                            })
                        }
                } else {
                    this.setState({
                        isLoader: false,
                        isSGLoader: false,
                        messageApi: res.data.message,
                    })
                }

            } catch (err) {
                this.setState({
                    isLoader: false,
                    isSGLoader: false,
                    messageGigApi: 'Network Error'
                })
            }
        // }
    }

    getAllJobsApi = async (page, istester, search) => {
        try {
            if (this._ismounted) {
                this.setState({
                    isLoader: true,
                    allJobs: []
                });


                const headers = {
                    'Authorization': sessionStorage.getItem('token')
                }

                let formData = new FormData();
                formData.append('show_tester', istester ? 1 : 0)
                formData.append('page_no', page)
                formData.append('job_type', 'POST')
                formData.append('sort_by', this.state.sortByVal)
                if (this.state.rangeVal === 1) {
                    // formData.append('month', this.state.manuDate)
                    // formData.append('year', this.state.manuDate)
                    formData.append('date_from', this.state.startDate)
                    formData.append('date_to', this.state.endDate)
                }

                formData.append('client_status', this.state.cJobStatus)
                // formData.append('client_country', null)
                formData.append('service_category_id', this.state.typeServices)
                formData.append('involved_admin', this.state.iAdmin)
                formData.append('search_by', search)

                const response = await apiHalper('getJobsTypeAll', 'POST', formData, headers);
                const res = response.data;
                if (res.status) {
                    const data = jwtDecode(res.data);
                    const jobData= data.job_data;
                    this.setState({
                        isLoader: false,
                        allJobs: data.job_data,
                        totalRecord: data.count
                    });
                } else {
                    this.setState({
                        isLoader: false,
                        allJobs: [],
                        totalRecord: 0
                    });
                }
            }
        } catch (err) {
            this.setState({
                apiMessage: err.message,
                isLoader: false,
                allJobs: [],
                totalRecord: 0
            });
        }
    }

    placeBid = async () => {
        try {

            this.setState({
                isLoader: true
            });
                const headers = {
                    'Authorization': sessionStorage.getItem('token'),
                }

                let formData = new FormData();
                formData.append('profile_id', this.state.aiProfileId)
                formData.append('job_post_id', this.state.jobPostId)
                formData.append('message', this.state.message)
                formData.append('currency', this.state.currency)
                formData.append('amount', this.state.amount)
                formData.append('deadline_type', this.state.deadline_type)
                formData.append('deadline_value', this.state.deadline_value)
          
                const response = await apiHalper('addJobBid', 'POST', formData, headers);
                const res = response.data;
                if (res.status) {
                    const decode = jwtDecode(res.data)
                    this.setState({
                        apiError: '',
                        isSLoader: false,
                        openBiddingModal: false,
                    });
                    toster_sucess(res.message);
                }
                else { 
                    toster_error(res.message);
                    this.setState({
                        isSLoader: false,
                        openBiddingModal: false,
                    })
                }
            
        } catch (err) {
            this.setState({
                apiMessage: err.message,
                isLoader: false,
                allJobs: [],
                totalRecord: 0
            });
        }
    }

    handleCheckAll = (e) => {
        var selectedList;
        if(this.state.allJobs[0].id == undefined){
            selectedList = Array.isArray(this.state.allJobs) ? this.state.allJobs.map(({ cityID }) => (cityID)) : [];
        }else{
            selectedList = Array.isArray(this.state.allJobs) ? this.state.allJobs.map(({ id }) => (id)) : [];
        }
        
        if(e.target.checked){
            selectedList.map((data) => {
                document.getElementById(data).checked = true;
            })
            this.setState({
                selectedRow: selectedList,
                isSelectAll: true,
            })
        }else{
            selectedList.map((data) => {
                document.getElementById(data).checked = false;
            })
            this.setState({
                selectedRow: [],
                isSelectAll: false,
            })
        }

        console.log('selectedList ', selectedList)
    }

    headerSpan = (column, colIndex) => {
        switch (column.dataField) {
            case 'check':
                return <span className={column.sort ? "header_span sort imgRight" : "header_span text-left imgRight"}><label className="custom-checkbox table-header-checkbox"><input type="checkbox" id='checkAll' readOnly onChange={(e)=> this.handleCheckAll(e)} /><span className="checkmark"></span> ALL</label></span>;
            case 'id':
                return <span className={column.sort ? "header_span sort text-center imgRight" : "header_span text-center imgRight"}>{column.text}</span>;
            case 'bid_count':
                return <span className={column.sort ? "header_span sort text-center imgRight" : "header_span text-center imgRight"}>{column.text}</span>;
            case 'budget':
                return <span className={column.sort ? "header_span sort text-center imgRight" : "header_span text-center imgRight"}>{column.text}</span>;
            case 'timestamp':
                return <span className={column.sort ? "header_span sort text-center imgRight" : "header_span text-center imgRight"}>{column.text}</span>;
            case 'job_post_state_id':
                return <span className={column.sort ? "header_span sort text-center imgRight" : "header_span text-center imgRight"}>{column.text}</span>;
            case 'client_rate':
                return <span className={column.sort ? "header_span sort text-center imgRight" : "header_span text-center imgRight"}>{column.text}</span>;
            case 'action':
                return <span className={column.sort ? "header_span sort text-center imgRight" : "header_span text-center imgRight"}>{column.text}</span>;
            default:
                return <span className={column.sort ? "header_span sort" : "header_span"}>{column.text}</span>;
        }
    }

    statusField = (cell) => {

        switch (cell) {
            case 1:
                return <button type="button" className="btn-status btn-status2 minWd_220 red margin_0auto" disabled>{'Waiting for deposit'}</button>;
            case 2:
                return <button type="button" className="btn-status btn-status2 minWd_220 blue margin_0auto" disabled>{'In Progress'}</button>;
            case 3:
                return <button type="button" className="btn-status btn-status2 minWd_220 orange margin_0auto" disabled>{'Bidding'}</button>;
            case 4:
                return <button type="button" className="btn-status btn-status2 minWd_220 green margin_0auto" disabled>{'Completed'}</button>;
            case 5:
                return <button type="button" className="btn-status btn-status2 minWd_220 red margin_0auto" disabled>{'Cancelled'}</button>;
            case 6:
                return <button type="button" className="btn-status btn-status2 minWd_220 orange margin_0auto" disabled>{'Waiting for my acceptance'}</button>;
            case 7:
                return <button type="button" className="btn-status btn-status2 minWd_220 orange margin_0auto" disabled>{'Waiting for agent acceptance'}</button>;
            case 8:
                return <button type="button" className="btn-status btn-status2 minWd_220 orange margin_0auto" disabled>{'Submit-Waiting for Release'}</button>;
            case 9:
                return <button type="button" className="btn-status btn-status2 minWd_220 red margin_0auto" disabled>{'Refunded'}</button>;
            case 10:
                return <button type="button" className="btn-status btn-status2 minWd_220 red margin_0auto" disabled>{'Auto Rejected Bid'}</button>;
            case 11:
                return <button type="button" className="btn-status btn-status2 minWd_220 red margin_0auto" disabled>{'Removed'}</button>;
            case 12:
                return <button type="button" className="btn-status btn-status2 minWd_220 red margin_0auto" disabled>{'Under review'}</button>;
            case 13:
                return <button type="button" className="btn-status btn-status2 minWd_220 red margin_0auto" disabled>{'Rejected Job'}</button>;
            case 14:
                return <button type="button" className="btn-status btn-status2 minWd_220 orange margin_0auto" disabled>{'Blocked/Reported'}</button>;
            default:
                return <button type="button" className="btn-status btn-status2 minWd_220 margin_0auto" disabled>--</button>;
        }

    }
    checkStateField = (cell, row) => {  
        return <label className="custom-checkbox"><input type="checkbox" id={row.id} key={row.id} onChange={(e)=> {this.handleCheck(e, row.id)}} /><span className="checkmark"></span></label>;
    }
    centerField = (cell) => {
        return <span className="text-center margin_0auto">{cell}</span>;
    }

    amountField = (cell, row) => {
        const { range_from, range_to } = row;
        // console.log(client_rate);
        return <span className="text-center margin_0auto">${range_from} - ${range_to}</span>;
    }

    // actionField = (cell, row) => {
    //     localStorage.setItem('jobID', row.id);
    //     localStorage.setItem('profileID', row.profile_id);
    // return <Link to={`/jobsDetails/${row.id}?type=jobs`} className="btn-view margin_0auto" onClick={() => this.viewDetail(row)}>Views</Link>
  
    // }

    actionField = (cell, row) => {
        localStorage.setItem('jobID', row.id);
        localStorage.setItem('profileID', row.profile_id);
        return <div className="action_group text-center">
            < Link to={`/jobsDetails/${row.id}?type=jobs`} className="btn-view" onClick={() => this.viewDetail(row)}>View</Link>
            <button type="button" className="btn-bid" onClick={() => this.viewAIAgent(row.id)}>Bid</button>
        </div>
    }

    viewAIAgent = (jobID) => {
        this.setState({
            isBidModal: true,
            jobPostId: jobID
        })
        this.getAIAgentsListApi(1);
        
    }
    viewDetail = (data) => {
        const { detailView } = this.props
        detailView(data);
    }

    openDeleModal = (id) => {
        this.setState({
            isDeleModal: true,
            deleteId: id
        })
    }

   

    cancelDelete = () => {
        this.setState({
            isDeleModal: false
        })
    }
    dateField = (cell, row) => {
        return <span className="text-center margin_0auto">{moment(cell).format('MMM DD, YYYY')}</span>;
    }

    handleTableChange = (type, { page, sizePerPage, searchText, sortField, sortOrder, data }) => {
        let result;
        if (sortOrder === 'asc') {
            result = data.sort((a, b) => {
                if (a[sortField] > b[sortField]) {
                    return 1;
                } else if (b[sortField] > a[sortField]) {
                    return -1;
                }
                return 0;
            });
        } else {
            result = data.sort((a, b) => {
                if (a[sortField] > b[sortField]) {
                    return -1;
                } else if (b[sortField] > a[sortField]) {
                    return 1;
                }
                return 0;
            });
        }
        this.setState(() => ({
            data: result
        }))

        const { istester } = this.state;

        if (type === 'pagination') {
            this.setState({
                page,
                sizePerPage
            });
            this.getAllJobsApi(page, istester, searchText);
        }

        if (type === 'search') {
            this.setState({
                search: searchText
            });
            this.getAllJobsApi(page, istester, searchText);
        }
    }

    isTester = (row) => {
        // console.log(row)
        let classs = null;
        if (row.is_tester) {
            classs = 'tester_tr'
        } else {
            classs = null;
        }

        return classs;
    }

    testerHandler = (e) => {
        // const { checked } = e.target;
        this.setState({
            istester: !this.state.istester,
        });

        const { page, search } = this.state;
        this.getAllJobsApi(page, !this.state.istester, search);
    }

    // filter handler
    sortByHandler = (val) => {
        this.setState({
            sortByVal: val
        });
    }

    rangeHandler = val => {
        this.setState({
            rangeVal: val
        })
    }

    manuDateHandler = val => {
        this.setState({
            manuDate: val
        });
    }

    handleStartdate = (event, picker) => {
        const startDate = picker.startDate._d;
        this.setState({
            startDate: startDate,
            manFilterVal: null
        });
    }

    handleEnddate = (event, picker) => {
        const endDate = picker.endDate._d;
        this.setState({
            endDate: endDate,
            manFilterVal: null
        });
    }

    handleCountry = selectedOption => {
        this.setState({ selectedCountry: selectedOption });
    };

    toggleClearable = () => {
        this.setState(state => ({ isClearable: !state.isClearable }));
    }

    jobStatusHandler = val => {
        this.setState({
            cJobStatus: val
        });
    }

    adminHandler = val => {
        this.setState({
            iAdmin: val
        })
    }

    serviceHandler = val => {
        this.setState({
            typeServices: val
        })
    }

    applyHandler = e => {
        e.preventDefault();
        const { openFilter } = this.props;
        const { page, istester, search } = this.state;
        this.getAllJobsApi(page, istester, search);
        openFilter();
    }

    handleCheck = (e, row_id) => {
        if(e.target.checked){
            var selected = this.state.selectedRow
            selected.push(row_id)
            this.setState({
                selectedRow: selected,
                isSelectAll: true,
            })
        }else{
            var selected = this.state.selectedRow
            var selectedArr = selected.filter(function(e) { return e !== row_id })
            this.setState({
                selectedRow: selectedArr,
            })
            if(selectedArr.length <= 0){
                this.setState({
                    isSelectAll: false,
                })
            }
        }
    }

    closeModal = () => {
        this.setState({
            isBidModal: false,
            aiAgentData:[],
        })
    }

    closeBiddingModal = () => {
        this.setState({
            openBiddingModal:false
        })
    }

    renderList = (data, i) => {
        return <li key={i}>
            <div className="review_block">
                <div className="review_titleWrap">
                    <h6>{data.username}</h6>
                </div>
                <button type="button" className="btn-bid" onClick={() => this.openBiddingModal(data.profileID)}> Bid </button>

            </div>
        </li>
    }


    openBiddingModal = (id) => {
        this.setState({
            openBiddingModal: true,
            aiProfileId: id
        })
    }
    nextpageGigReviews = () => {
        const inc = this.state.page + 1;
        if (this.state.isLoader) {
            this.setState({
                page: inc
            })
            this.getAIAgentsListApi(inc)
        } else {
            this.setState({
                isLoader: false
            })
        }

    }

    handleSelectionChange = (event) => {
        this.setState({ deadline_type: event.target.value });
      };


    inputHandler = e => {
        const { name, value } = e.target;
        this.setState({
            [name]: value,
        }, () => this.validationChecked(name, value));
    }
    validationChecked = (name, value) => {
        let error = this.state.formError;
        let valid = this.state.formValid;
        switch (name) {
            case 'amount':
                valid.amount = value.length > 0;
                error.amount = valid.amount ? '' : 'Amount is required!';
                break;
            case 'deadline_value':
                valid.delivery = value.length > 0;
                error.delivery = valid.delivery ? '' : 'deadline_value is required!';
                break;
            case 'deadline_type':
                valid.deadline_type = value.length > 0;
                error.deadline_type = valid.deadline_type ? '' : 'deadline_type is required!';
                break;
            case 'currency':
                valid.currency = value.length > 0;
                error.currency = valid.currency ? '' : 'currency is required!';
                break;
            case 'message':
                valid.message = value.length > 0;
                error.message = valid.message ? '' : 'message is required!';
                break;
            default:
                break;
        };

        this.setState({
            formError: error,
            formValid: valid
        });
    }
    // filter handler over

    render() {
        
        const columns = [
           // { dataField: 'id', text: '#', sort: false, headerFormatter: this.headerSpan },
            { dataField: 'check', text: '', sort: false, headerFormatter: this.headerSpan, formatter: this.checkStateField },
            { dataField: 'title', text: 'Title', sort: true, headerFormatter: this.headerSpan },
            { dataField: 'id', text: 'Job ID', sort: true, headerFormatter: this.headerSpan, formatter: this.centerField },
            { dataField: 'timestamp', text: 'Time', sort: true, headerFormatter: this.headerSpan, formatter: this.dateField },
            { dataField: 'job_post_state_id', text: 'Status', sort: true, headerFormatter: this.headerSpan, formatter: this.statusField },
            { dataField: 'bid_count', text: 'No of Bid', sort: true, headerFormatter: this.headerSpan, formatter: this.centerField },
            { dataField: 'budget', text: 'Budget', sort: true, headerFormatter: this.headerSpan, formatter: this.centerField },
            { dataField: 'client_rate', text: 'Amount', sort: true, headerFormatter: this.headerSpan, formatter: this.amountField },
            { dataField: 'action', text: 'Action', sort: false, headerFormatter: this.headerSpan, formatter: this.actionField }
        ];

        const tableData = {
            columns: columns,
            data: this.state.allJobs,
            keyId: 'id',
            loading: this.state.isLoader,
            message: 'Table is Empty',
            noDataIndication: <NoDataIndication />,
            page: this.state.page,
            totalRecord: this.state.totalRecord,
            sizePerPage: 10,
            handleTableChange: this.handleTableChange,
            rowClass: this.isTester
        };

        const { openFilter, isPJFModal } = this.props;

        const clientStatusArray = [
            { status: 'Any Status', statusID: 0, inputID: 'allAnystatus' },
            { status: 'Waiting for deposit', statusID: 1, inputID: 'wfDStatus' },
            { status: 'In Progress', statusID: 2, inputID: 'inPrgStatus' },
            { status: 'Bidding', statusID: 3, inputID: 'bidStatus' },
            { status: 'Completed', statusID: 4, inputID: 'complStatus' },
            { status: 'Cancelled', statusID: 5, inputID: 'cancStatus' },
            { status: 'Waiting for my acceptance', statusID: 6, inputID: 'wfmaStatus' },
            { status: 'Waiting for agent acceptance', statusID: 7, inputID: 'wfaaStatus' },
            { status: 'Submit-Waiting for Release', statusID: 8, inputID: 'swfrStatus' },
            { status: 'Refunded', statusID: 9, inputID: 'refStatus' },
            { status: 'Auto Rejected Bid', statusID: 10, inputID: 'arbStatus' },
            { status: 'Removed', statusID: 11, inputID: 'remStatus' },
            { status: 'Under review', statusID: 12, inputID: 'urStatus' },
            { status: 'Rejected Job', statusID: 13, inputID: 'rejJobStatus' },
            { status: 'Blocked/Reported', statusID: 14, inputID: 'blkRepoStatus' }
        ]

        const fieldName = {
            sortBy: {
                name: 'post_sortBy',
                newOld: 'postNewOld',
                oldNew: 'postOldNew'
            },
            dateRange: {
                name: 'post_dateRange',
                date_range: 'postDate_range',
                custom_range: 'postCustom_range',
                custom_name: 'post_customRange',
                month: 'post',
                year: 'postYear'
            },
            cjs: {
                name: 'post_clientStatus',
                cateArray: clientStatusArray
            },
            iba: {
                name: 'post_involvedAdmin',
                iAdmin1: 'postiAdmin1',
                iAdmin2: 'postiAdmin2',
                iAdmin3: 'postiAdmin3',
                iAdmin4: 'postiAdmin4',
                iAdmin5: 'postiAdmin5'
            },
            toservices: {
                name: 'post_typeServices',
                serviceArray: this.state.mainServices
            }
        }

        const modalData = {
            sortByVal: this.state.sortByVal,
            rangeVal: this.state.rangeVal,
            manuDate: this.state.manuDate,
            startDate: this.state.startDate,
            endDate: this.state.endDate,
            cJobStatus: this.state.cJobStatus,
            iAdmin: this.state.iAdmin,
            typeServices: this.state.typeServices,
            selectedCountry: this.state.selectedCountry,
            isClearable: this.state.isClearable,
            sortByHandler: this.sortByHandler,
            rangeHandler: this.rangeHandler,
            manuDateHandler: this.manuDateHandler,
            handleStartdate: this.handleStartdate,
            handleEnddate: this.handleEnddate,
            jobStatusHandler: this.jobStatusHandler,
            adminHandler: this.adminHandler,
            serviceHandler: this.serviceHandler,
            applyHandler: this.applyHandler,
            handleCountry: this.handleCountry,
            toggleClearable: this.toggleClearable
        }
        const { isDeleModal, selectedRow, isSelectAll, aiAgentData, isLoader, messageApi, isSGLoader, jobPostId, formError, formValid} = this.state;
        return (
            <Fragment>
                <div className="tab_container"> 
                    <div className="tester_view">
                        <p>Tester Recorded</p>
                        <button type="button" className={this.state.istester ? "button_checkbox active" : "button_checkbox"} onClick={this.testerHandler}>
                            <span className="label_text"></span>
                        </button>
                    </div>
                    <div className="delete_btn">
                        {isSelectAll ? 
                            <button className="btn-delete-all" onClick={() => this.openDeleModal(selectedRow)}>DELETE</button>
                        :null
                        }   
                    </div>
                    <div className="filter_btnGroup">
                        <button type="button" className="btn_filterM" onClick={openFilter}></button>
                    </div>
                 
                    <DataTable TableData={tableData} />
                </div>

                <Modal show={this.state.isBidModal} onHide={this.closeModal} className="modal_design_bid" size="md" aria-labelledby="contained-modal-title-vcenter" centered>
                            <Modal.Body>
                                <div className="review_wrap">
                                    <h6 className="subpage_title">AI Agents </h6>
                                    <ul className="review_list_bid" id="scrollableUl">
                                        <InfiniteScroll className="review_list width-forscrool" dataLength={aiAgentData.length} next={this.nextpageGigReviews} hasMore={isSGLoader} loader={<ScrollLoader />} scrollableTarget="scrollableUl">
                                            {aiAgentData.map((info, i) => this.renderList(info, i))}
                                        </InfiniteScroll>
                                    </ul>
                                </div>
                            </Modal.Body>
                </Modal>
                <Modal show={this.state.openBiddingModal} onHide={this.closeBiddingModal} className="modal_design_bid" size="md" aria-labelledby="contained-modal-title-vcenter" centered>
                            <Modal.Body>
                                <div className="review_wrap">
                                    <h6 className="subpage_title">Place a bid </h6>
                                    {/* <ul className="review_list_bid"> */}
                                        <form method="POST" action="#" onSubmit={this.placeBid} >
                                            <div className="form_group divd_wrap">
                                                <div className="wid_full">
                                                    <label>Paid to you</label>
                                                    <input type="number" name="amount" className= "form_control2" onChange={this.inputHandler} placeholder="$"/>
                                                    {formError.amount !== '' ? <p className="error_text">{formError.amount}</p> : null}
                                                </div>
                                                <div className="wid_full">
                                                    <label>Currency</label>
                                                    <input type="text" name="currency" className="form_control" value={this.state.currency}/>

                                                </div>
                                            </div>
                                            <div className="form_group divd_wrap">
                                                <div className="wid_full">
                                                    <label>Delivery in</label>
                                                    <input type="number" name="deadline_value" className="form_control2" onChange={this.inputHandler}/>
                                                    {formError.delivery !== '' ? <p className="error_text">{formError.delivery}</p> : null}

                                                </div>
                                                <div className="wid_full">
                                                    <label>Days</label>
                                                    <select value={this.state.deadline_type} onChange={this.handleSelectionChange} className='form_control'>
                                                        <option value="days">days</option>
                                                        <option value="hours">hours</option>
                                                    </select>

                                                </div>
                                            </div>
                                            <div className="form_group divd_wrap">
                                                <div className="wid_full">
                                                    <label>Describe your Bid</label>
                                                    <textarea name="message" className= "form_control2 textarea" placeholder={'Enter Description'}  onChange={this.inputHandler}></textarea>
                                                    {formError.message !== '' ? <p className="error_text">{formError.message}</p> : null}
                                                </div>
                                            </div>
                                            <div className="form_group divd_wrap">
                                             <button type="button" className="btn-place-bid" onClick={this.placeBid}>Place a Bid</button>
                                            </div>
                                        </form>
                                    {/* </ul> */}
                                </div>
                            </Modal.Body>
                </Modal>
                <JobsFilterM field={fieldName} data={modalData} isModal={isPJFModal} closeEvent={openFilter} />
                <DeleteModal isModal={isDeleModal} id={selectedRow} handleClose={this.cancelDelete} />
                {/* //<ToastContainer /> */}
            </Fragment>
        )
    }
}

const mapStateToProps = state => ({
    isPJFModal: state.allJobs.isPJFModal
})

const mapDispatchToProps = dispatch => ({
    openFilter: () => dispatch({ type: ACTION_TYPES.TOGGLE_JOBS_ALLFILTER_MODAL }),
    detailView: (data) => dispatch({ type: ACTIVE_TYPES.JOB_VIEW_DETAIL, payload: data })
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PostList));
